module.exports = __webpack_public_path__ + "img/weixinerweima.233c1a0d.jpg";